// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file storage/storage.proto (package vsmr.storage.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";

/**
 * Size limits of this service's requests — their one declaration. The enum only carries the numbers into every
 * generated language: the BFF enforces them, the web checks before sending. No message field uses it.
 *
 * @generated from enum vsmr.storage.v1.StorageLimit
 */
export enum StorageLimit {
  /**
   * @generated from enum value: STORAGE_LIMIT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Largest UploadFile content in bytes (64 MiB). The BFF's request body limit for UploadFile is derived from it
   * (the JSON encoding carries bytes as base64, 4/3 larger, plus the envelope).
   *
   * @generated from enum value: STORAGE_LIMIT_UPLOAD_FILE_MAX_BYTES = 67108864;
   */
  UPLOAD_FILE_MAX_BYTES = 67108864,
}
// Retrieve enum metadata with: proto3.getEnumType(StorageLimit)
proto3.util.setEnumType(StorageLimit, "vsmr.storage.v1.StorageLimit", [
  { no: 0, name: "STORAGE_LIMIT_UNSPECIFIED" },
  { no: 67108864, name: "STORAGE_LIMIT_UPLOAD_FILE_MAX_BYTES" },
]);

/**
 * Response after file upload
 *
 * @generated from message vsmr.storage.v1.UploadFileResponse
 */
export class UploadFileResponse extends Message<UploadFileResponse> {
  /**
   * Upload success status
   *
   * @generated from field: bool success = 1;
   */
  success = false;

  /**
   * Full object key (path) where file was stored
   *
   * @generated from field: string object_key = 2;
   */
  objectKey = "";

  /**
   * Status message or error description
   *
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * Uploaded file size in bytes
   *
   * @generated from field: int64 size = 4;
   */
  size = protoInt64.zero;

  /**
   * Full s3:// URL (s3://bucket/object_key) for use as MARS input_file arg
   *
   * @generated from field: string file_url = 5;
   */
  fileUrl = "";

  constructor(data?: PartialMessage<UploadFileResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.storage.v1.UploadFileResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "object_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "size", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "file_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UploadFileResponse {
    return new UploadFileResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UploadFileResponse {
    return new UploadFileResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UploadFileResponse {
    return new UploadFileResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UploadFileResponse | PlainMessage<UploadFileResponse> | undefined, b: UploadFileResponse | PlainMessage<UploadFileResponse> | undefined): boolean {
    return proto3.util.equals(UploadFileResponse, a, b);
  }
}

/**
 * Request to copy object
 *
 * @generated from message vsmr.storage.v1.CopyFileRequest
 */
export class CopyFileRequest extends Message<CopyFileRequest> {
  /**
   * Source object key
   *
   * @generated from field: string src_object_key = 1;
   */
  srcObjectKey = "";

  /**
   * Destination object key
   *
   * @generated from field: string dst_object_key = 2;
   */
  dstObjectKey = "";

  constructor(data?: PartialMessage<CopyFileRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.storage.v1.CopyFileRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "src_object_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "dst_object_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CopyFileRequest {
    return new CopyFileRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CopyFileRequest {
    return new CopyFileRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CopyFileRequest {
    return new CopyFileRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CopyFileRequest | PlainMessage<CopyFileRequest> | undefined, b: CopyFileRequest | PlainMessage<CopyFileRequest> | undefined): boolean {
    return proto3.util.equals(CopyFileRequest, a, b);
  }
}

/**
 * Response after file copy
 *
 * @generated from message vsmr.storage.v1.CopyFileResponse
 */
export class CopyFileResponse extends Message<CopyFileResponse> {
  /**
   * Copy success status
   *
   * @generated from field: bool success = 1;
   */
  success = false;

  /**
   * Status message or error description
   *
   * @generated from field: string message = 2;
   */
  message = "";

  constructor(data?: PartialMessage<CopyFileResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.storage.v1.CopyFileResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CopyFileResponse {
    return new CopyFileResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CopyFileResponse {
    return new CopyFileResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CopyFileResponse {
    return new CopyFileResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CopyFileResponse | PlainMessage<CopyFileResponse> | undefined, b: CopyFileResponse | PlainMessage<CopyFileResponse> | undefined): boolean {
    return proto3.util.equals(CopyFileResponse, a, b);
  }
}

/**
 * Request to list result files
 *
 * @generated from message vsmr.storage.v1.ListResultFilesRequest
 */
export class ListResultFilesRequest extends Message<ListResultFilesRequest> {
  /**
   * Project identifier(uuid)
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  /**
   * Simulation identifier(uuid)
   *
   * @generated from field: string simulation_id = 2;
   */
  simulationId = "";

  /**
   * Model identifier(uuid)
   *
   * @generated from field: string model_id = 3;
   */
  modelId = "";

  /**
   * Task index within the simulation(starting from 0)
   *
   * @generated from field: int32 task_index = 4;
   */
  taskIndex = 0;

  constructor(data?: PartialMessage<ListResultFilesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.storage.v1.ListResultFilesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "simulation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "model_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "task_index", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListResultFilesRequest {
    return new ListResultFilesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListResultFilesRequest {
    return new ListResultFilesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListResultFilesRequest {
    return new ListResultFilesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListResultFilesRequest | PlainMessage<ListResultFilesRequest> | undefined, b: ListResultFilesRequest | PlainMessage<ListResultFilesRequest> | undefined): boolean {
    return proto3.util.equals(ListResultFilesRequest, a, b);
  }
}

/**
 * File info
 *
 * @generated from message vsmr.storage.v1.FileInfo
 */
export class FileInfo extends Message<FileInfo> {
  /**
   * Full object key in the storage system
   *
   * @generated from field: string object_key = 1;
   */
  objectKey = "";

  /**
   * File name
   *
   * @generated from field: string file_name = 2;
   */
  fileName = "";

  /**
   * File size in bytes
   *
   * @generated from field: int64 size = 3;
   */
  size = protoInt64.zero;

  /**
   * MIME type
   *
   * @generated from field: string content_type = 4;
   */
  contentType = "";

  /**
   * Last modified timestamp (ISO-8601 string)
   *
   * @generated from field: string last_modified = 5;
   */
  lastModified = "";

  constructor(data?: PartialMessage<FileInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.storage.v1.FileInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "object_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "file_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "size", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "content_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "last_modified", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FileInfo {
    return new FileInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FileInfo {
    return new FileInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FileInfo {
    return new FileInfo().fromJsonString(jsonString, options);
  }

  static equals(a: FileInfo | PlainMessage<FileInfo> | undefined, b: FileInfo | PlainMessage<FileInfo> | undefined): boolean {
    return proto3.util.equals(FileInfo, a, b);
  }
}

/**
 * Response after file copy
 *
 * @generated from message vsmr.storage.v1.ListResultFilesResponse
 */
export class ListResultFilesResponse extends Message<ListResultFilesResponse> {
  /**
   * List of file info associated with the task
   *
   * @generated from field: repeated vsmr.storage.v1.FileInfo files = 1;
   */
  files: FileInfo[] = [];

  constructor(data?: PartialMessage<ListResultFilesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.storage.v1.ListResultFilesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "files", kind: "message", T: FileInfo, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListResultFilesResponse {
    return new ListResultFilesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListResultFilesResponse {
    return new ListResultFilesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListResultFilesResponse {
    return new ListResultFilesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListResultFilesResponse | PlainMessage<ListResultFilesResponse> | undefined, b: ListResultFilesResponse | PlainMessage<ListResultFilesResponse> | undefined): boolean {
    return proto3.util.equals(ListResultFilesResponse, a, b);
  }
}

/**
 * Request to download file
 *
 * @generated from message vsmr.storage.v1.DownloadFileRequest
 */
export class DownloadFileRequest extends Message<DownloadFileRequest> {
  /**
   * Object key of the file to download
   *
   * @generated from field: string object_key = 1;
   */
  objectKey = "";

  constructor(data?: PartialMessage<DownloadFileRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.storage.v1.DownloadFileRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "object_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DownloadFileRequest {
    return new DownloadFileRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DownloadFileRequest {
    return new DownloadFileRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DownloadFileRequest {
    return new DownloadFileRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DownloadFileRequest | PlainMessage<DownloadFileRequest> | undefined, b: DownloadFileRequest | PlainMessage<DownloadFileRequest> | undefined): boolean {
    return proto3.util.equals(DownloadFileRequest, a, b);
  }
}

/**
 * Request to download a task result file
 *
 * @generated from message vsmr.storage.v1.DownloadTaskResultFileRequest
 */
export class DownloadTaskResultFileRequest extends Message<DownloadTaskResultFileRequest> {
  /**
   * Project identifier(uuid)
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  /**
   * Simulation identifier(uuid)
   *
   * @generated from field: string simulation_id = 2;
   */
  simulationId = "";

  /**
   * Model identifier(uuid)
   *
   * @generated from field: string model_id = 3;
   */
  modelId = "";

  /**
   * Task index within the simulation(starting from 0)
   *
   * @generated from field: int32 task_index = 4;
   */
  taskIndex = 0;

  /**
   * Target file name to download
   *
   * @generated from field: string file_name = 5;
   */
  fileName = "";

  constructor(data?: PartialMessage<DownloadTaskResultFileRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.storage.v1.DownloadTaskResultFileRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "simulation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "model_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "task_index", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "file_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DownloadTaskResultFileRequest {
    return new DownloadTaskResultFileRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DownloadTaskResultFileRequest {
    return new DownloadTaskResultFileRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DownloadTaskResultFileRequest {
    return new DownloadTaskResultFileRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DownloadTaskResultFileRequest | PlainMessage<DownloadTaskResultFileRequest> | undefined, b: DownloadTaskResultFileRequest | PlainMessage<DownloadTaskResultFileRequest> | undefined): boolean {
    return proto3.util.equals(DownloadTaskResultFileRequest, a, b);
  }
}

/**
 * Response after file download
 *
 * @generated from message vsmr.storage.v1.DownloadFileResponse
 */
export class DownloadFileResponse extends Message<DownloadFileResponse> {
  /**
   * file info
   *
   * @generated from field: vsmr.storage.v1.FileInfo file = 1;
   */
  file?: FileInfo;

  /**
   * Binary chunk of the file content
   *
   * @generated from field: bytes chunk = 2;
   */
  chunk = new Uint8Array(0);

  constructor(data?: PartialMessage<DownloadFileResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.storage.v1.DownloadFileResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "file", kind: "message", T: FileInfo },
    { no: 2, name: "chunk", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DownloadFileResponse {
    return new DownloadFileResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DownloadFileResponse {
    return new DownloadFileResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DownloadFileResponse {
    return new DownloadFileResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DownloadFileResponse | PlainMessage<DownloadFileResponse> | undefined, b: DownloadFileResponse | PlainMessage<DownloadFileResponse> | undefined): boolean {
    return proto3.util.equals(DownloadFileResponse, a, b);
  }
}

/**
 * Request to upload content to an object key in the caller's own space
 *
 * @generated from message vsmr.storage.v1.UploadFileRequest
 */
export class UploadFileRequest extends Message<UploadFileRequest> {
  /**
   * Full object key, e.g. {user_id}/{project_id}/simulation/{sim_id}/0/inputs/PRI.i
   *
   * @generated from field: string object_key = 1;
   */
  objectKey = "";

  /**
   * File content as bytes — at most STORAGE_LIMIT_UPLOAD_FILE_MAX_BYTES
   *
   * @generated from field: bytes content = 2;
   */
  content = new Uint8Array(0);

  /**
   * MIME type (e.g., "text/plain")
   *
   * @generated from field: string content_type = 3;
   */
  contentType = "";

  constructor(data?: PartialMessage<UploadFileRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.storage.v1.UploadFileRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "object_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "content", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "content_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UploadFileRequest {
    return new UploadFileRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UploadFileRequest {
    return new UploadFileRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UploadFileRequest {
    return new UploadFileRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UploadFileRequest | PlainMessage<UploadFileRequest> | undefined, b: UploadFileRequest | PlainMessage<UploadFileRequest> | undefined): boolean {
    return proto3.util.equals(UploadFileRequest, a, b);
  }
}

/**
 * Request to list the objects under a prefix in the caller's own space
 *
 * @generated from message vsmr.storage.v1.ListFilesRequest
 */
export class ListFilesRequest extends Message<ListFilesRequest> {
  /**
   * Folder key without the trailing slash, e.g. {user_id}/_quickrun
   *
   * @generated from field: string object_prefix = 1;
   */
  objectPrefix = "";

  /**
   * true: every object below (directory markers — objects whose key ends in "/" — left out); false: immediate children (sub-folders as folder entries)
   *
   * @generated from field: bool recursive = 2;
   */
  recursive = false;

  constructor(data?: PartialMessage<ListFilesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.storage.v1.ListFilesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "object_prefix", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "recursive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListFilesRequest {
    return new ListFilesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListFilesRequest {
    return new ListFilesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListFilesRequest {
    return new ListFilesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListFilesRequest | PlainMessage<ListFilesRequest> | undefined, b: ListFilesRequest | PlainMessage<ListFilesRequest> | undefined): boolean {
    return proto3.util.equals(ListFilesRequest, a, b);
  }
}

/**
 * One listed entry
 *
 * @generated from message vsmr.storage.v1.ListedObject
 */
export class ListedObject extends Message<ListedObject> {
  /**
   * Full key; a folder entry ends with "/"
   *
   * @generated from field: string object_key = 1;
   */
  objectKey = "";

  /**
   * Folder entry — only in a non-recursive listing
   *
   * @generated from field: bool is_folder = 2;
   */
  isFolder = false;

  /**
   * Size in bytes (0 for folders)
   *
   * @generated from field: int64 size = 3;
   */
  size = protoInt64.zero;

  /**
   * Last modified timestamp (ISO-8601, empty for folders)
   *
   * @generated from field: string last_modified = 4;
   */
  lastModified = "";

  constructor(data?: PartialMessage<ListedObject>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.storage.v1.ListedObject";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "object_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_folder", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "size", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "last_modified", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListedObject {
    return new ListedObject().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListedObject {
    return new ListedObject().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListedObject {
    return new ListedObject().fromJsonString(jsonString, options);
  }

  static equals(a: ListedObject | PlainMessage<ListedObject> | undefined, b: ListedObject | PlainMessage<ListedObject> | undefined): boolean {
    return proto3.util.equals(ListedObject, a, b);
  }
}

/**
 * Response of ListFiles
 *
 * @generated from message vsmr.storage.v1.ListFilesResponse
 */
export class ListFilesResponse extends Message<ListFilesResponse> {
  /**
   * @generated from field: repeated vsmr.storage.v1.ListedObject entries = 1;
   */
  entries: ListedObject[] = [];

  constructor(data?: PartialMessage<ListFilesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.storage.v1.ListFilesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "entries", kind: "message", T: ListedObject, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListFilesResponse {
    return new ListFilesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListFilesResponse {
    return new ListFilesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListFilesResponse {
    return new ListFilesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListFilesResponse | PlainMessage<ListFilesResponse> | undefined, b: ListFilesResponse | PlainMessage<ListFilesResponse> | undefined): boolean {
    return proto3.util.equals(ListFilesResponse, a, b);
  }
}

/**
 * Request to delete objects by key in the caller's own space
 *
 * @generated from message vsmr.storage.v1.DeleteFilesRequest
 */
export class DeleteFilesRequest extends Message<DeleteFilesRequest> {
  /**
   * Full object keys
   *
   * @generated from field: repeated string object_keys = 1;
   */
  objectKeys: string[] = [];

  constructor(data?: PartialMessage<DeleteFilesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.storage.v1.DeleteFilesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "object_keys", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteFilesRequest {
    return new DeleteFilesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteFilesRequest {
    return new DeleteFilesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteFilesRequest {
    return new DeleteFilesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteFilesRequest | PlainMessage<DeleteFilesRequest> | undefined, b: DeleteFilesRequest | PlainMessage<DeleteFilesRequest> | undefined): boolean {
    return proto3.util.equals(DeleteFilesRequest, a, b);
  }
}

/**
 * Response of DeleteFiles
 *
 * @generated from message vsmr.storage.v1.DeleteFilesResponse
 */
export class DeleteFilesResponse extends Message<DeleteFilesResponse> {
  /**
   * Distinct keys sent for deletion and not reported as failed
   *
   * @generated from field: int32 deleted = 1;
   */
  deleted = 0;

  /**
   * Keys the store reported as not deleted
   *
   * @generated from field: repeated string failed = 2;
   */
  failed: string[] = [];

  constructor(data?: PartialMessage<DeleteFilesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.storage.v1.DeleteFilesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "deleted", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "failed", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteFilesResponse {
    return new DeleteFilesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteFilesResponse {
    return new DeleteFilesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteFilesResponse {
    return new DeleteFilesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteFilesResponse | PlainMessage<DeleteFilesResponse> | undefined, b: DeleteFilesResponse | PlainMessage<DeleteFilesResponse> | undefined): boolean {
    return proto3.util.equals(DeleteFilesResponse, a, b);
  }
}

